import { PERMISSIONS } from './permissions';

const WALLET_TYPES = [
  {
    name: 'All wallets',
    value: 'all',
    permission: PERMISSIONS.BALANCE_VIEW
  },
  {
    name: 'Fiat wallets',
    value: 'fiat',
    permission: PERMISSIONS.BALANCE_VIEW
  },
  {
    name: 'Crypto wallets',
    value: 'crypto',
    permission: PERMISSIONS.BALANCE_VIEW
  }
];

const ACCOUNT_TYPES = [
  {
    label: 'Fiat',
    value: 'FIAT',
    settlement_percent: 1.5
  },
  {
    label: 'Crypto',
    value: 'CRYPTO',
    settlement_percent: 0.5
  }
];

export { ACCOUNT_TYPES, WALLET_TYPES };
